import { render, staticRenderFns } from "./products-filters.vue?vue&type=template&id=6d88a411&scoped=true&"
import script from "./products-filters.vue?vue&type=script&lang=js&"
export * from "./products-filters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d88a411",
  null
  
)

export default component.exports